import React, { useEffect, useState } from "react";
import { API } from "../../config/api";
import "./../Styles/profile.css";
export default function Terms() {
  const [rules, setRules] = useState({});
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    fetch("/rules.json")
      .then((res) => res.json())
      .then((data) => setRules(data));

    fetchUser();
  }, []);

  const fetchUser = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user) return;

    try {
      const res = await fetch(`${API.GET_USER}&id=${user.id}`);
      const data = await res.json();

      if (data.success) {
        let options = [];

        try {
          options = JSON.parse(data.user.provider_options || "[]");
        } catch {
          options = [];
        }

        setProviders(options.filter((x) => x !== "visitor"));
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="rules-page">
      <div className="rules-container">
        <h1>Rules & Regulations</h1>

        <p>
          Please follow the rules below according to the services you provide.
        </p>

        {providers
          .filter((provider) => {
            const ruleData = rules[provider];

            return (
              ruleData &&
              ruleData.title &&
              ((Array.isArray(ruleData.rules) && ruleData.rules.length > 0) ||
                (Array.isArray(ruleData.sections) &&
                  ruleData.sections.length > 0))
            );
          })
          .map((provider) => {
            const ruleData = rules[provider];

            return (
              <div className="rule-card" key={provider}>
                <h2>{ruleData.title}</h2>

                {/* NORMAL RULES */}
                {Array.isArray(ruleData.rules) && (
                  <ul>
                    {ruleData.rules.map((rule, index) => (
                      <li key={index}>{rule}</li>
                    ))}
                  </ul>
                )}

                {/* SECTION RULES (DESIGNS) */}
                {Array.isArray(ruleData.sections) &&
                  ruleData.sections.map((section, index) => (
                    <div key={index} className="rule-section">
                      <h5>{section.heading}</h5>

                      <ul>
                        {section.rules.map((rule, i) => (
                          <li key={i}>{rule}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
              </div>
            );
          })}
      </div>
    </div>
  );
}
